export function getColorFromName(name) {
  const nameNoSpaces = name?.toLowerCase()?.replace(/\s+/g, "");

  let charSum = 0;

  for (let i = 0; i < nameNoSpaces?.length; i++) {
    charSum += nameNoSpaces.charCodeAt(i);
  }

  const r = (charSum * 123) % 256;
  const g = (charSum * 456) % 256;
  const b = (charSum * 789) % 256;

  const lightR = Math.floor(200 + (r / 256) * 55);
  const lightG = Math.floor(200 + (g / 256) * 55);
  const lightB = Math.floor(200 + (b / 256) * 55);

  const color = `#${((1 << 24) + (lightR << 16) + (lightG << 8) + lightB)
    .toString(16)
    .slice(1)}`;

  return color;
}
